const ArrowToolIcon = ({ isActive }: any) => {
  const finalColor = isActive ? "white" : "#0C172C";

  const size = "24px";

  return (
    <svg width={size} height={size} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1879 13.6446C15.7166 13.6775 15.3518 13.3127 15.3852 12.8419L16.0024 4.00132L2.63552 17.36C2.27125 17.7233 1.73073 17.761 1.41444 17.4447C1.09816 17.1284 1.12772 16.5797 1.49148 16.216L14.8583 2.85728L6.02541 3.48213C5.54643 3.50737 5.1811 3.14203 5.21451 2.67123C5.24856 2.18345 5.66874 1.76327 6.14713 1.73862L17.0806 0.975328C17.5607 0.93361 17.9255 1.29844 17.8833 1.77805L17.1205 12.712C17.0953 13.191 16.6757 13.6106 16.1879 13.6446Z"
        fill={finalColor}
      />
    </svg>
  );
};

export default ArrowToolIcon;
